// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.whisper_loginForm__z9GTU {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
}

.whisper_button__W8axU {
  margin-top: 8px;
  color: #090909;
  padding: 0.7em 1.7em;
  border-radius: 0.5em;
  cursor: pointer;
  height: -moz-fit-content;
  height: fit-content;
  border: 1px solid #e8e8e8;
  transition: all 0.3s;
  width: 100%;
}

.whisper_informationContainer__Uzoxv {
  display: flex;
  flex-direction: column;
  max-width: 100%;
  justify-content: center;
  align-items: center;
  padding: 36px;
}

.whisper_select__nMJMI {
  width: 550px;
}

.whisper_container__930ST {
  width: 80%;
  margin: auto;
  font-family: Arial, sans-serif;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-top: 16px;
}

h2 {
  border-bottom: 2px solid #ddd;
  padding-bottom: 5px;
}

.whisper_demography__ufBOb,
.whisper_lastClinicalIntake__rNpin,
.whisper_appointmentHistory__sWoHG {
  display: flex;
  flex-direction: column;
  gap: 20px;
  div {
    label {
      color: black !important;
    }
  }
}

.whisper_demography__ufBOb,
.whisper_lastClinicalIntake__rNpin,
.whisper_appointmentHistory__sWoHG,
.whisper_messageHistory__5nNSU,
.whisper_conversation__\\+83LE {
  background: #f9f9f9;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.whisper_conversation__\\+83LE {
  display: flex;
  align-self: center;
  margin-top: 16px;
  width: calc(80% - 40px);
}

p {
  margin: 5px 0;
}

hr {
  border: 0;
  border-top: 1px solid #eee;
  margin: 10px 0;
}

.whisper_appointmentHistory__sWoHG div,
.whisper_messageHistory__5nNSU div {
  margin-bottom: 10px;
}

.whisper_messageHistory__5nNSU {
  display: flex;
  flex-direction: column;
}

.whisper_message__lQcrf {
  display: flex;
  flex-direction: column;
  max-width: 70%;
}

.whisper_message__lQcrf.whisper_user__Jqouv {
  align-self: flex-end;
  align-items: flex-end;
}

.whisper_message__lQcrf.whisper_copilot__EDloo {
  align-self: flex-start;
  align-items: flex-start;
}

.whisper_messageDate__Omfo6 {
  font-size: 0.8rem;
  color: #888;
}

.whisper_messageUser__Ftjdv {
  font-weight: bold;
}

.whisper_messageBubble__UjB1g {
  background: #e0e0e0;
  border-radius: 8px;
  padding: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.whisper_message__lQcrf.whisper_user__Jqouv .whisper_messageBubble__UjB1g {
  background: #007bff;
  color: white;
}

.whisper_spinner__QaH8k {
  margin-top: 8px;
}

.whisper_result__eeulz {
  background: #f9f9f9;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
  max-width: 80%;
}

.whisper_conversation__\\+83LE {
  min-height: 250px;
}

@media screen and (max-width: 760px) {
  .whisper_select__nMJMI {
    width: 350px;
  }

  .whisper_container__930ST {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .whisper_demography__ufBOb,
  .whisper_lastClinicalIntake__rNpin,
  .whisper_appointmentHistory__sWoHG,
  .whisper_messageHistory__5nNSU {
    width: 100%;
  }

  .whisper_conversation__\\+83LE {
    width: 80%;
  }

  .whisper_message__lQcrf {
    max-width: 90%;
  }
}

.whisper_resultContainer__ZOgod {
  width: 80%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin-top: 16px;
  gap: 16px;
}

.whisper_resultBox__P08rX {
  background: #f9f9f9;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 16px;
  min-height: 70px;
  border-radius: 8px;
}

.whisper_highlight__RxjsB {
  h2 {
    color: rgb(7, 211, 7) !important;
  }
}

@media screen and (max-width: 860px) {
  .whisper_resultContainer__ZOgod {
    grid-template-columns: repeat(1, 1fr);
  }
}

@media screen and (max-width: 500px) {
  .whisper_informationContainer__Uzoxv {
    padding: 16px;
  }

  .whisper_message__lQcrf {
    max-width: 100%;
  }
}

@media screen and (max-width: 420px) {
  .whisper_select__nMJMI {
    width: 200px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Whisper/whisper.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;EACf,wBAAmB;EAAnB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT;IACE;MACE,uBAAuB;IACzB;EACF;AACF;;AAEA;;;;;EAKE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;;;;IAIE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,UAAU;EACV,aAAa;EACb,qCAAqC;EACrC,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":[".loginForm {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n}\n\n.button {\n  margin-top: 8px;\n  color: #090909;\n  padding: 0.7em 1.7em;\n  border-radius: 0.5em;\n  cursor: pointer;\n  height: fit-content;\n  border: 1px solid #e8e8e8;\n  transition: all 0.3s;\n  width: 100%;\n}\n\n.informationContainer {\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n  justify-content: center;\n  align-items: center;\n  padding: 36px;\n}\n\n.select {\n  width: 550px;\n}\n\n.container {\n  width: 80%;\n  margin: auto;\n  font-family: Arial, sans-serif;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n  margin-top: 16px;\n}\n\nh2 {\n  border-bottom: 2px solid #ddd;\n  padding-bottom: 5px;\n}\n\n.demography,\n.lastClinicalIntake,\n.appointmentHistory {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  div {\n    label {\n      color: black !important;\n    }\n  }\n}\n\n.demography,\n.lastClinicalIntake,\n.appointmentHistory,\n.messageHistory,\n.conversation {\n  background: #f9f9f9;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.conversation {\n  display: flex;\n  align-self: center;\n  margin-top: 16px;\n  width: calc(80% - 40px);\n}\n\np {\n  margin: 5px 0;\n}\n\nhr {\n  border: 0;\n  border-top: 1px solid #eee;\n  margin: 10px 0;\n}\n\n.appointmentHistory div,\n.messageHistory div {\n  margin-bottom: 10px;\n}\n\n.messageHistory {\n  display: flex;\n  flex-direction: column;\n}\n\n.message {\n  display: flex;\n  flex-direction: column;\n  max-width: 70%;\n}\n\n.message.user {\n  align-self: flex-end;\n  align-items: flex-end;\n}\n\n.message.copilot {\n  align-self: flex-start;\n  align-items: flex-start;\n}\n\n.messageDate {\n  font-size: 0.8rem;\n  color: #888;\n}\n\n.messageUser {\n  font-weight: bold;\n}\n\n.messageBubble {\n  background: #e0e0e0;\n  border-radius: 8px;\n  padding: 10px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.message.user .messageBubble {\n  background: #007bff;\n  color: white;\n}\n\n.spinner {\n  margin-top: 8px;\n}\n\n.result {\n  background: #f9f9f9;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  margin-top: 20px;\n  max-width: 80%;\n}\n\n.conversation {\n  min-height: 250px;\n}\n\n@media screen and (max-width: 760px) {\n  .select {\n    width: 350px;\n  }\n\n  .container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .demography,\n  .lastClinicalIntake,\n  .appointmentHistory,\n  .messageHistory {\n    width: 100%;\n  }\n\n  .conversation {\n    width: 80%;\n  }\n\n  .message {\n    max-width: 90%;\n  }\n}\n\n.resultContainer {\n  width: 80%;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  margin-top: 16px;\n  gap: 16px;\n}\n\n.resultBox {\n  background: #f9f9f9;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  padding: 16px;\n  min-height: 70px;\n  border-radius: 8px;\n}\n\n.highlight {\n  h2 {\n    color: rgb(7, 211, 7) !important;\n  }\n}\n\n@media screen and (max-width: 860px) {\n  .resultContainer {\n    grid-template-columns: repeat(1, 1fr);\n  }\n}\n\n@media screen and (max-width: 500px) {\n  .informationContainer {\n    padding: 16px;\n  }\n\n  .message {\n    max-width: 100%;\n  }\n}\n\n@media screen and (max-width: 420px) {\n  .select {\n    width: 200px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loginForm": `whisper_loginForm__z9GTU`,
	"button": `whisper_button__W8axU`,
	"informationContainer": `whisper_informationContainer__Uzoxv`,
	"select": `whisper_select__nMJMI`,
	"container": `whisper_container__930ST`,
	"demography": `whisper_demography__ufBOb`,
	"lastClinicalIntake": `whisper_lastClinicalIntake__rNpin`,
	"appointmentHistory": `whisper_appointmentHistory__sWoHG`,
	"messageHistory": `whisper_messageHistory__5nNSU`,
	"conversation": `whisper_conversation__+83LE`,
	"message": `whisper_message__lQcrf`,
	"user": `whisper_user__Jqouv`,
	"copilot": `whisper_copilot__EDloo`,
	"messageDate": `whisper_messageDate__Omfo6`,
	"messageUser": `whisper_messageUser__Ftjdv`,
	"messageBubble": `whisper_messageBubble__UjB1g`,
	"spinner": `whisper_spinner__QaH8k`,
	"result": `whisper_result__eeulz`,
	"resultContainer": `whisper_resultContainer__ZOgod`,
	"resultBox": `whisper_resultBox__P08rX`,
	"highlight": `whisper_highlight__RxjsB`
};
export default ___CSS_LOADER_EXPORT___;
